import type { PaymentMethod } from 'models/purchaseFlowRevamp'

import { usePfStore } from '../../store'
import { useIsFreeCart } from './chargeable'
import { useBillingPaymentMethods } from './useBillingPaymentMethods'

/**
 * The method the order is placed with: the client's pick, else the method Billing preselects.
 *
 * The preselect is never written to the store (a persisted write would dirty every draft on each
 * Billing mount), so anything deciding whether Stripe runs must read this, not `paymentMethod`.
 */
export const useEffectivePaymentMethod = (): PaymentMethod | undefined => {
  const stored = usePfStore((s) => s.paymentMethod)
  const { defaultPaymentMethod } = useBillingPaymentMethods()
  return stored ?? defaultPaymentMethod
}

/** Whether this cart is paid through Stripe at checkout: a card or SEPA method on a cart with something to charge. */
export const useIsChargedAtCheckout = (): boolean => {
  const method = useEffectivePaymentMethod()
  const isFreeCart = useIsFreeCart()
  return (method === 'card' || method === 'sepa') && !isFreeCart
}
